import './loader.css';

export default function Loader({ fullscreen = false }) {
  return (
    <div className={fullscreen ? 'loader-wrap fullscreen' : 'loader-wrap'}>
      <div className="spinner"></div>
    </div>
  );
}
